import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-778acc3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nft-viewer-con" }
const _hoisted_2 = { class: "nft-viewer" }
const _hoisted_3 = {
  key: 0,
  class: "nft-viewer-title"
}
const _hoisted_4 = { class: "nft-viewer-detail" }
const _hoisted_5 = { class: "nft-viewer-detail-first" }
const _hoisted_6 = { class: "nft-viewer-action" }
const _hoisted_7 = { class: "nft-viewer-action-left" }
const _hoisted_8 = {
  key: 0,
  class: "nft-viewer-action-right"
}
const _hoisted_9 = { class: "nft-viewer-detail-second" }
const _hoisted_10 = {
  key: 1,
  class: "nft-viewer-desc"
}
const _hoisted_11 = { class: "nft-viewer-card" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_14 = { class: "nft-viewer-card-item" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_16 = { class: "nft-viewer-card-item" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_18 = { class: "nft-viewer-card-item" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "text-zink-450"
}
const _hoisted_21 = { class: "nft-viewer-card mb-8" }
const _hoisted_22 = { class: "card-title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_24 = { class: "nft-viewer-card-item" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "nft-viewer-card-item" }
const _hoisted_28 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "nft-viewer-card-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex items-center" }, " BSC ", -1))
const _hoisted_32 = { class: "nft-viewer-card-item" }
const _hoisted_33 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_34 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_TypeOwner = _resolveComponent("TypeOwner")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BurnAlertModal = _resolveComponent("BurnAlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.nft && _ctx.nft.character)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.nft.character?.toUpperCase() || ''), 1))
          : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 1,
              rounded: "2xl",
              class: "nft-viewer-title"
            })),
        (_ctx.upToLargeBreakpoint)
          ? (_openBlock(), _createBlock(_component_TypeOwner, {
              key: 2,
              nft: _ctx.nft
            }, null, 8, ["nft"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.nft && _ctx.nft.image)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({ backgroundImage: `url(${_ctx.nft.image})` }),
                  class: "nft-viewer-image"
                }, null, 4))
              : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 1,
                  rounded: "2xl",
                  class: "nft-viewer-image"
                })),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_BalBtn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyLink())),
                  class: "mr-2 lg:mr-4",
                  circle: "",
                  color: "white",
                  size: _ctx.upToLargeBreakpoint ? 'sm' : 'md'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BalIcon, {
                      name: _ctx.copiedLink ? 'akar-icons:check' : 'carbon:share',
                      class: "text-zink-750",
                      size: _ctx.upToLargeBreakpoint ? 'sm' : 'md'
                    }, null, 8, ["name", "size"])
                  ]),
                  _: 1
                }, 8, ["size"]),
                _createVNode(_component_BalBtn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadImage())),
                  circle: "",
                  color: "white",
                  size: _ctx.upToLargeBreakpoint ? 'sm' : 'md'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BalIcon, {
                      name: "fluent:arrow-download-16-regular",
                      class: "text-zink-750",
                      size: _ctx.upToLargeBreakpoint ? 'sm' : 'md'
                    }, null, 8, ["size"])
                  ]),
                  _: 1
                }, 8, ["size"])
              ]),
              (_ctx.isUserNft)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_BalBtn, {
                      onClick: _ctx.makeAvatar,
                      class: "mr-2 lg:mr-4",
                      color: "amber",
                      size: _ctx.upToLargeBreakpoint ? 'sm' : 'md',
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('make_avatar')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "size"]),
                    _createVNode(_component_BalBtn, {
                      onClick: _ctx.trade,
                      class: "w-28 mr-2 lg:mr-4",
                      color: "amber",
                      size: _ctx.upToLargeBreakpoint ? 'sm' : 'md',
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('trade')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "size"]),
                    _createVNode(_component_BalBtn, {
                      class: "w-28",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenBurnAlertModal = true)),
                      color: "amber",
                      size: _ctx.upToLargeBreakpoint ? 'sm' : 'md',
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('burn_nft')), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.upToLargeBreakpoint)
              ? (_openBlock(), _createBlock(_component_TypeOwner, {
                  key: 0,
                  nft: _ctx.nft
                }, null, 8, ["nft"]))
              : _createCommentVNode("", true),
            (_ctx.nft && _ctx.nft.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.nft.description), 1))
              : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 2,
                  rounded: "2xl",
                  class: "nft-viewer-desc"
                })),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('attributes')), 1),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('rank').toUpperCase()), 1),
                (_ctx.nft && _ctx.nft.attributes[1].value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.nft.attributes[1].value) + " ", 1))
                  : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 1,
                      rounded: "md",
                      class: "nft-viewer-value-loading"
                    }))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('type')), 1),
                (_ctx.nft && _ctx.nft.attributes[2].value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.nft.attributes[2].value) + " ", 1))
                  : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 1,
                      rounded: "md",
                      class: "nft-viewer-value-loading"
                    }))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.route.params.key === 'acs'
                  ? _ctx.$t('acs_in_vault')
                  : _ctx.$t('acsi_in_vault')), 1),
                (_ctx.nft && _ctx.nft.stakedShow)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createTextVNode(_toDisplayString(`${_ctx.nft.stakedShow}`) + "   ", 1),
                      (_ctx.nft.stakedUsdShow)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "($" + _toDisplayString(_ctx.nft.stakedUsdShow) + ")", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 1,
                      rounded: "md",
                      class: "nft-viewer-value-loading"
                    }))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('attributes')), 1),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('contract')), 1),
                _createElementVNode("span", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.shorten(_ctx.collectionData.address)) + " ", 1),
                  _createElementVNode("a", {
                    class: "ml-2 lg:ml-3 cursor-pointer",
                    href: _ctx.explorerLinks.addressLink(_ctx.collectionData.address),
                    target: "_blank"
                  }, [
                    _createVNode(_component_BalIcon, {
                      name: "bi:arrow-up-right-circle",
                      size: _ctx.upToLargeBreakpoint ? 'xs' : 'smd'
                    }, null, 8, ["size"])
                  ], 8, _hoisted_26)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('token_id')), 1),
                (_ctx.nft && _ctx.nft.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_ctx.nft.id) + " ", 1),
                      _createElementVNode("a", {
                        class: "ml-2 lg:ml-3 cursor-pointer",
                        href: 
                    _ctx.explorerLinks.tokenLink(
                      `${_ctx.collectionData.address}?a=${_ctx.nft.id}`
                    )
                  ,
                        target: "_blank"
                      }, [
                        _createVNode(_component_BalIcon, {
                          name: "bi:arrow-up-right-circle",
                          size: _ctx.upToLargeBreakpoint ? 'xs' : 'smd',
                          class: "ml-2 lg:ml-3"
                        }, null, 8, ["size"])
                      ], 8, _hoisted_29)
                    ]))
                  : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 1,
                      rounded: "md",
                      class: "nft-viewer-value-loading"
                    }))
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('blockchain')), 1),
                _hoisted_31
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('metadata')), 1),
                (_ctx.nft && _ctx.nft.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.$t('centralized')) + " ", 1),
                      _createElementVNode("a", {
                        class: "ml-2 lg:ml-3 cursor-pointer",
                        href: `${_ctx.collectionData.baseUri}/${_ctx.nft.id}`,
                        target: "_blank"
                      }, [
                        _createVNode(_component_BalIcon, {
                          name: "bi:arrow-up-right-circle",
                          size: _ctx.upToLargeBreakpoint ? 'xs' : 'smd'
                        }, null, 8, ["size"])
                      ], 8, _hoisted_34)
                    ]))
                  : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 1,
                      rounded: "md",
                      class: "nft-viewer-value-loading"
                    }))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_BurnAlertModal, {
      nft: _ctx.nft,
      isOpen: _ctx.isOpenBurnAlertModal,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenBurnAlertModal = false))
    }, null, 8, ["nft", "isOpen"])
  ], 64))
}